import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { DossierService } from "src/app/suivi-portefeuille/core/service/dossier.service";
import { Dossier } from "src/app/suivi-portefeuille/core/model/dossier";

interface Alert {
  type: string;
  message: string;
}

@Component({
  selector: "app-dossier-impaye-tab",
  templateUrl: "./dossier-impaye-tab.component.html",
  styleUrls: ["./dossier-impaye-tab.component.scss"],
})
export class DossierImpayeTabComponent implements OnInit {
  alerts: Alert[] = [];

  pressButton: Boolean = false;

  dossiers: Dossier[];

  codeClient: String;

  requestEncours: Request;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _dossierService: DossierService
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.codeClient = params["codeClient"];
      this.dossiersImpayesByCodeClient(this.codeClient);
    });
  }

  dossiersImpayesByCodeClient(codeclient) {
    this._dossierService.findAllImpayeByCodeClient(codeclient).subscribe(
      (data) => {
        this.dossiers = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  close(alert: Alert) {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }

  voirEcheance(numDossier): void {
    this._router.navigate(["/suivi-portefeuille/detail-dossier/" + numDossier]);
  }
}
